import { Countries } from "@foundation-tool/ui/types";

export enum QuestionGroups {
  AboutYou = "conociendote",
  SkinTone = "tono",
  SkinSubTone = "subtono",
  FoundationKind = "tipo-de-base",
  FoundationKindPowder = "tipo-de-polvo",
}

export enum Questions {
  Question1 = "tipo-de-piel",
  Question2 = "edad",
  Question3 = "tono-intro",
  Question4 = "tono",
  Question5 = "subtono-intro",
  Question6 = "venas",
  Question7 = "joyas",
  Question8 = "piel-al-sol",
  Question9 = "cobertura",
  Question10 = "acabado",
  Question11 = "beneficios",
  Question12 = "refinamiento-tono",
}

export enum QuestionsPowder {
  Question1 = "tipo-de-piel",
  Question2 = "edad",
  Question3 = "tono-intro",
  Question4 = "tono",
  Question5 = "subtono-intro",
  Question6 = "venas",
  Question7 = "joyas",
  Question8 = "piel-al-sol",
  Question9 = "cobertura",
  Question10 = "acabado",
  Question11 = "beneficios",
  Question12 = "refinamiento-tono",
}

export interface QuestionConfig {
  stepAnswer: number;
  iteration?: number;
  isIntroStep?: boolean;
  question: Questions;
  nextQuestionPathname?: string;
  prevQuestionPathname?: string;
  GA4TrackEvent?: (elementName: string, elementDetail: string) => void;
}

export type QuestionaryConfig = Record<string, QuestionConfig[]>;

export interface QuestionOption<TValue = string> {
  value: TValue;
  label: string;
  width?: string;
  //optionState = QuestionConfig & Answer
}

export interface QuestionAnsewerConfig<TValue = string> {
  title: string;
  subtitle?: string;
  description?: string;
  isServerSide?: boolean;
  questionName: Questions;
  options: QuestionOption<TValue>[];
}

export interface PageContext {
  iteration?: number;
  group: QuestionGroups;
  questionConfig: QuestionConfig;
  countryIso: Countries;
  isOnlyTone?: boolean;
  isPowder?: boolean;
}
export interface BaseQuestionProps {
  questionConfig: QuestionConfig;
  iteration?: number;
  countryIso: Countries;
  isOnlyTone?: boolean;
  isPowder?: boolean;
}
